import { EscapedString, html as svg } from '../c-mp/fun/html'
import { url } from '../c-mp/fun/url'
import { DATAURI_DEATH_BLACK } from '../model/DATAURI_DEATH_BLACK'
import type { IPerson } from '../model/IPerson'
import { alignCenter } from './alignCenter'
import { formatDateShort } from './formatDateShort'
import { getServerUrl } from './getServerUrl'
import {
	FONT_SIZE_SMALL,
	IMAGE_MARGIN,
	IMAGE_SIZE,
	LABEL_HEIGHT,
	LABEL_RADIUS,
	LABEL_SHADOW_OFFSET,
	LABEL_TOP,
	LABEL_WIDTH,
	LINE_HEIGHT,
	PERSON_PADDING_X,
	PERSON_WIDTH,
} from './makeSvgTree'

export function drawPerson({
	test,
	content,
	person,
	imageUrl,
	x,
	y,
	isFocused,
	relationship,
}: {
	test: SVGElement
	content: (EscapedString | string)[]
	person: IPerson | null | undefined
	imageUrl: string | null | undefined
	x: number
	y: number
	isFocused?: boolean
	relationship?: string
}) {
	const textX = x + PERSON_PADDING_X * 2 + IMAGE_SIZE + 4
	const firstLineY = y + LABEL_TOP + LINE_HEIGHT + 2
	let href = ''
	if (person) {
		href = getServerUrl() + url`/person/${person.id}`
	}
	content.push(
		svg`<a id="${person?.id}" href="${href}">`,
		relationship == null
			? ''
			: svg`<rect
					x="${x + PERSON_PADDING_X + IMAGE_SIZE + IMAGE_MARGIN}"
					y="${y + LABEL_TOP - LINE_HEIGHT}"
					width="${LABEL_WIDTH - IMAGE_SIZE - LABEL_RADIUS}"
					height="${LINE_HEIGHT + LABEL_RADIUS}"
					rx="${LABEL_RADIUS}"
					fill="white"
				/>`,
		relationship == null
			? ''
			: alignCenter(
					test,
					svg`<text
						y="${y + LABEL_TOP - 6}"
						style="font-style: italic; font-size: ${FONT_SIZE_SMALL}px"
					>
						${relationship}
					</text>`,
					x + PERSON_WIDTH / 2,
				),
		svg`<path
			d="M ${x + PERSON_PADDING_X + LABEL_SHADOW_OFFSET},${y + LABEL_TOP + LABEL_SHADOW_OFFSET}
				m ${IMAGE_MARGIN + IMAGE_SIZE / 2},0
				h ${LABEL_WIDTH - IMAGE_MARGIN - IMAGE_SIZE / 2 - LABEL_RADIUS}
				a ${LABEL_RADIUS} ${LABEL_RADIUS} 90 0 1 ${LABEL_RADIUS} ${LABEL_RADIUS}
				v ${LABEL_HEIGHT - LABEL_RADIUS * 2}
				a ${LABEL_RADIUS} ${LABEL_RADIUS} 90 0 1 ${-LABEL_RADIUS} ${LABEL_RADIUS}
				h ${-(LABEL_WIDTH - IMAGE_MARGIN - IMAGE_SIZE / 2 - LABEL_RADIUS)}
				a ${IMAGE_SIZE / 2 + IMAGE_MARGIN} ${IMAGE_SIZE / 2 + IMAGE_MARGIN} 180 0 1 0 ${-(IMAGE_SIZE + IMAGE_MARGIN * 2)}
				z"
			fill="black"
			stroke="black"
			stroke-width="${isFocused ? 4 : 2}"
			paint-order="markers stroke fill"
		/>`,
		svg`<path
			d="M ${x + PERSON_PADDING_X},${y + LABEL_TOP}
				m ${IMAGE_MARGIN + IMAGE_SIZE / 2},0
				h ${LABEL_WIDTH - IMAGE_MARGIN - IMAGE_SIZE / 2 - LABEL_RADIUS}
				a ${LABEL_RADIUS} ${LABEL_RADIUS} 90 0 1 ${LABEL_RADIUS} ${LABEL_RADIUS}
				v ${LABEL_HEIGHT - LABEL_RADIUS * 2}
				a ${LABEL_RADIUS} ${LABEL_RADIUS} 90 0 1 ${-LABEL_RADIUS} ${LABEL_RADIUS}
				h ${-(LABEL_WIDTH - IMAGE_MARGIN - IMAGE_SIZE / 2 - LABEL_RADIUS)}
				a ${IMAGE_SIZE / 2 + IMAGE_MARGIN} ${IMAGE_SIZE / 2 + IMAGE_MARGIN} 180 0 1 0 ${-(IMAGE_SIZE + IMAGE_MARGIN * 2)}
				z"
			fill="white"
			stroke="black"
			stroke-width="${isFocused ? 4 : 2}"
			paint-order="markers stroke fill"
		/>`,
		imageUrl === DATAURI_DEATH_BLACK
			? svg`<use
					href="#infant-death"
					x="${x + PERSON_PADDING_X + IMAGE_MARGIN}"
					y="${y + LABEL_TOP + IMAGE_MARGIN}"
				/>`
			: imageUrl
				? svg`<image
						x="${x + PERSON_PADDING_X + IMAGE_MARGIN}"
						y="${y + LABEL_TOP + IMAGE_MARGIN}"
						width="${IMAGE_SIZE}"
						height="${IMAGE_SIZE}"
						href="${imageUrl}"
						clip-path="url(#image-clip)"
					/>
					<circle
						cx="${x + PERSON_PADDING_X + IMAGE_MARGIN + IMAGE_SIZE / 2}"
						cy="${y + LABEL_TOP + IMAGE_MARGIN + IMAGE_SIZE / 2}"
						r="${IMAGE_SIZE / 2 - 0.25}"
						stroke="black"
						stroke-width="0.5"
						stroke-opacity="0.4"
						fill="none"
					/>`
				: '' /* svg`<use
					x="${x + PERSON_PADDING_X + IMAGE_MARGIN}"
					y="${y + LABEL_TOP + IMAGE_MARGIN}"
					width="${IMAGE_SIZE}"
					height="${IMAGE_SIZE}"
					href="#missing"
				/>` */,
		svg`<text x="${textX}" y="${firstLineY}">
			${person?.honorific} ${person?.lastName}
		</text>`,
		svg`<text
			x="${textX}"
			y="${firstLineY + LINE_HEIGHT}"
			style="font-weight: bold"
		>
			${person?.firstName}
		</text>`,
		person?.birthDate || person?.deathDate
			? svg`<text
			x="${textX}"
			y="${firstLineY + LINE_HEIGHT * 2}"
			style="font-size: ${FONT_SIZE_SMALL}px"
		>
			<tspan>${formatDateShort(person?.birthDate) || '          '}<title>${person?.birthPlace ?? `Ismeretlen helyen`}</title></tspan> – <tspan>${formatDateShort(person?.deathDate)}<title>${person?.deathPlace ?? `Ismeretlen helyen`}</title></tspan>
		</text>`
			: '',
		`</a>`,
	)
}
